import injectorDirectiveFactory from 'gw-portals-util-angular/injectorDirectiveFactory';

import PropertyCodeDirective from './PropertyCode/PropertyCode';
import IndustryCodeDirective from './IndustryCode/IndustryCode';
import DefaultMatchDirective from './Default/Default';

var knownMatchContentDefinitions = [DefaultMatchDirective, PropertyCodeDirective, IndustryCodeDirective];
var moduleName = injectorDirectiveFactory('gwTypeaheadMatchContent', {
    directive: '&',
    index: '=',
    match: '=',
    query: '='
}, knownMatchContentDefinitions, ['$scope', function ($scope) {
    return $scope.directive();
}]);

export { moduleName as default, DefaultMatchDirective };


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/Injector.js
// module id = 358
// module chunks = 0